module.exports = __webpack_public_path__ + "img/comment_4_1.f4fd0657.jpg";